import { call, put } from 'redux-saga/effects';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import html2canvas from 'html2canvas';
import * as actions from '../actions/support';
import { startLoading, stopLoading } from '../actions/settings/loading';
import { modalErrorOpen } from '../actions/modalError';
import { post, del, get } from '../../utils/api';
import { getLocale } from '../../utils/functions';

/** Вызов всплывающего окна с сообщением */
function openNotify(text) {
  notify(
    {
      message: text,
      height: 64,
      width: 354,
      position: {
        at: 'top center',
        my: 'top center',
        offset: '0 48'
      }
    },
    'success',
    2000
  );
}

// Корректное отображение таблиц при использовании html2canvas
// body .dx-datagrid-content.dx-datagrid-content-fixed.dx-pointer-events-target{
//   width: fit-content;
//   max-width: fit-content;
//   table{
//     width: fit-content;
//     max-width: fit-content;
//   }
// }

const blobToFile = (theBlob, fileName) => {
  const newBlob = theBlob;
  newBlob.lastModifiedDate = new Date();
  newBlob.name = fileName;
  return newBlob;
};

/** Снимок экрана */
const getScreen = () => new Promise((resolve) => {
  html2canvas(document.body, {
    onclone(copy) {
      // Корректное отображение таблиц при использовании html2canvas
      const headingOverlayToHide = copy.querySelectorAll(
        'body .dx-datagrid-content.dx-datagrid-content-fixed.dx-pointer-events-target'
      );
      const tableOverlayToHide = copy.querySelectorAll(
        'body .dx-datagrid-content.dx-datagrid-content-fixed.dx-pointer-events-target table'
      );
      const widthRule = 'fit-content';
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < headingOverlayToHide.length; index++) {
        headingOverlayToHide[index].style.width = widthRule;
        headingOverlayToHide[index].style.maxWidth = widthRule;
        tableOverlayToHide[index].style.width = widthRule;
        tableOverlayToHide[index].style.maxWidth = widthRule;
      }
    }
  }).then((canvas) => {
    const time = new Date()
      .toISOString()
      .slice(0, -5)
      .replaceAll(':', '-');
    const path = window.location.pathname;
    canvas.toBlob((blob) => {
      resolve(
        blobToFile(
          blob,
          `img${path.replaceAll('sys', '').replaceAll('/', ' ')}_${time}.png`
        )
      );
    });
  });
});

/** Открытие окна обращения */
export function* openSupportWindow() {
  const path = window.location.pathname;
  const supportData = {
    path,
    attachments: []
  };
  try {
    yield put(actions.openSupportWindowSuccess());
    const screen = yield call(getScreen);
    supportData.attachments.push(screen);
  } finally {
    yield put(actions.setSupportInfo(supportData));
  }
}

/** Получить номер обращения */
export function* getSupportNextNumber() {
  try {
    const response = yield call(get, '/support/next_number');
    yield put(actions.getSupportNextNumberSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getSupportNextNumberFail());
  }
}

/** Добавление фото */
export function* supportAddPhoto({ payload }) {
  try {
    yield put(startLoading());
    const formData = new FormData();
    formData.append('supportNumber', payload.supportNumber);
    formData.append('file', payload.file);

    yield call(post, '/support/attachment/upload/', formData, {
      headers: {
        'Accept-Language': getLocale(),
        'Content-Type': 'multipart/form-data'
      }
    });
    yield put(actions.supportAddPhotoSuccess());
    yield put(
      actions.supportGetListPhotos({
        supportNumber: payload.supportNumber
      })
    );
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Удаление фото */
export function* supportDelPhoto({ payload }) {
  try {
    yield put(startLoading());
    // eslint-disable-next-line no-restricted-syntax
    for (const value of payload.listPhotos) {
      yield call(del, `/support/attachment/${value}`);
    }
    yield put(
      actions.supportGetListPhotos({
        supportNumber: payload.supportNumber
      })
    );
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Список фотографий */
export function* supportGetListPhotos({ payload }) {
  try {
    yield put(startLoading());
    const response = yield call(
      get,
      `/support/attachment/list/?supportNumber=${payload.supportNumber}`
    );
    yield put(actions.supportGetListPhotosSuccess(response));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}

/** Отправка email */
export function* supportSendEmail({ payload }) {
  try {
    yield put(startLoading());

    const formData = new FormData();
    formData.append('supportNumber', payload.supportNumber);
    formData.append('noteText', payload.body);
    if (payload.plantId && payload.plantId !== '-1') {
      formData.append('plantId', payload.plantId);
    }

    yield call(post, '/support/send-email', formData);
    yield put(actions.supportSendEmailSuccess());
    yield call(openNotify, formatMessage('dataSuccess'));
    yield put(stopLoading());
  } catch (error) {
    yield put(stopLoading());
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
  }
}
